declare namespace $ {

	type $mol_locale_select__dictionary_bog_testops_app_settings_1 = $mol_type_enforce<
		({ 
			'ru': string,
			'en': string,
		}) 
		,
		ReturnType< $mol_locale_select['dictionary'] >
	>
	type $mol_labeler__title_bog_testops_app_settings_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_testops_app_settings_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_string__hint_bog_testops_app_settings_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_testops_app_settings_5 = $mol_type_enforce<
		ReturnType< $bog_testops_app_settings['api_key'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_form_field__name_bog_testops_app_settings_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__content_bog_testops_app_settings_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form_field['content'] >
	>
	type $mol_select__hint_bog_testops_app_settings_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_select['hint'] >
	>
	type $mol_select__value_bog_testops_app_settings_9 = $mol_type_enforce<
		ReturnType< $bog_testops_app_settings['api_model'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__options_bog_testops_app_settings_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_form_field__name_bog_testops_app_settings_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__content_bog_testops_app_settings_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form_field['content'] >
	>
	type $mol_button_minor__click_bog_testops_app_settings_13 = $mol_type_enforce<
		ReturnType< $bog_testops_app_settings['api_test'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_testops_app_settings_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_card__title_bog_testops_app_settings_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_card['title'] >
	>
	type $mol_card__content_bog_testops_app_settings_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_card['content'] >
	>
	type $mol_string__hint_bog_testops_app_settings_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_testops_app_settings_18 = $mol_type_enforce<
		ReturnType< $bog_testops_app_settings['gitlab_token'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_form_field__name_bog_testops_app_settings_19 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__content_bog_testops_app_settings_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form_field['content'] >
	>
	type $mol_string__hint_bog_testops_app_settings_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_testops_app_settings_22 = $mol_type_enforce<
		ReturnType< $bog_testops_app_settings['gitlab_url'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_form_field__name_bog_testops_app_settings_23 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__content_bog_testops_app_settings_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form_field['content'] >
	>
	type $mol_string__hint_bog_testops_app_settings_25 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_testops_app_settings_26 = $mol_type_enforce<
		ReturnType< $bog_testops_app_settings['gitlab_project'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_form_field__name_bog_testops_app_settings_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__content_bog_testops_app_settings_28 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form_field['content'] >
	>
	type $mol_button_minor__click_bog_testops_app_settings_29 = $mol_type_enforce<
		ReturnType< $bog_testops_app_settings['gitlab_test'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_testops_app_settings_30 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_card__title_bog_testops_app_settings_31 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_card['title'] >
	>
	type $mol_card__content_bog_testops_app_settings_32 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_card['content'] >
	>
	type $mol_string__hint_bog_testops_app_settings_33 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_testops_app_settings_34 = $mol_type_enforce<
		ReturnType< $bog_testops_app_settings['allure_owner'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_form_field__name_bog_testops_app_settings_35 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__content_bog_testops_app_settings_36 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form_field['content'] >
	>
	type $mol_card__title_bog_testops_app_settings_37 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_card['title'] >
	>
	type $mol_card__content_bog_testops_app_settings_38 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_card['content'] >
	>
	type $mol_button_major__click_bog_testops_app_settings_39 = $mol_type_enforce<
		ReturnType< $bog_testops_app_settings['save'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__sub_bog_testops_app_settings_40 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_button_minor__click_bog_testops_app_settings_41 = $mol_type_enforce<
		ReturnType< $bog_testops_app_settings['reset'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_testops_app_settings_42 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_row__sub_bog_testops_app_settings_43 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	export class $bog_testops_app_settings extends $mol_page {
		Language_select( ): $mol_locale_select
		Language_labeler( ): $mol_labeler
		api_key( next?: string ): string
		ApiKey( ): $mol_string
		ApiKey_field( ): $mol_form_field
		api_model( next?: string ): string
		ApiModel( ): $mol_select
		ApiModel_field( ): $mol_form_field
		api_test( next?: any ): any
		api_test_label( ): string
		ApiTest_btn( ): $mol_button_minor
		ApiCard( ): $mol_card
		gitlab_token( next?: string ): string
		GitlabToken( ): $mol_string
		GitlabToken_field( ): $mol_form_field
		gitlab_url( next?: string ): string
		GitlabUrl( ): $mol_string
		GitlabUrl_field( ): $mol_form_field
		gitlab_project( next?: string ): string
		GitlabProject( ): $mol_string
		GitlabProject_field( ): $mol_form_field
		gitlab_test( next?: any ): any
		gitlab_test_label( ): string
		GitlabTest_btn( ): $mol_button_minor
		GitlabCard( ): $mol_card
		allure_owner( next?: string ): string
		AllureOwner( ): $mol_string
		AllureOwner_field( ): $mol_form_field
		AllureCard( ): $mol_card
		save( next?: any ): any
		save_label( ): string
		Save_btn( ): $mol_button_major
		reset( next?: any ): any
		reset_label( ): string
		Reset_btn( ): $mol_button_minor
		SaveRow( ): $mol_row
		title( ): string
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=settings.view.tree.d.ts.map